<template>
  <span v-if="user.information">
    <span v-if="!showMultiple">
      <b-button class="inlineBtn" variant="dark" @click="showSefosMessage = true" v-if="sefosEnabled">
        {{ $t("MESSAGES.COMPOSE") }}
      </b-button>
      <b-button class="inlineBtn" variant="dark" @click="showSdkMessage = true" v-if="sdkVisible">
        {{ $t("MESSAGES.COMPOSE") }}
      </b-button>
      <b-button class="inlineBtn" variant="dark" @click="showFaxMessage = true" v-if="faxVisible">
        {{ $t("MESSAGES.COMPOSE") }}
      </b-button>
    </span>
    <span v-if="showMultiple">
      <b-dropdown variant="dark">
        <template #button-content>{{ $t("MESSAGES.COMPOSE") }}</template>
        <b-dropdown-item href="#" @click="showSefosMessage = true" v-if="sefosEnabled"
          ><img class="icon mr-2" :alt="$t('MESSAGES.TYPE.message')" src="/img/message_type/message.png" /> {{ $t("MESSAGES.TYPE.message") }}</b-dropdown-item
        >
        <b-dropdown-item v-if="sdkVisible" href="#" @click="showSdkMessage = true"
          ><img class="icon mr-2" :alt="$t('MESSAGES.TYPE.sdk-message')" src="/img/message_type/sdk-message.png" /> {{ $t("MESSAGES.TYPE.sdk-message") }}</b-dropdown-item
        >
        <b-dropdown-item v-if="faxVisible" href="#" @click="showFaxMessage = true"
          ><img class="icon mr-2" :alt="$t('MESSAGES.TYPE.fax-message')" src="/img/message_type/fax-message.png" /> {{ $t("MESSAGES.TYPE.fax-message") }}</b-dropdown-item
        >
      </b-dropdown>      
    </span>
    <AddSefosMessage
      v-if="sefosEnabled"
      :show="showSefosMessage"
      :user_uuid="user_uuid"
      @changeShow="changeShowSefosMessage"
      @sentMessage="sentMessage"
      :functionbox_uuid="functionbox_uuid"
    ></AddSefosMessage>
    <AddSDKMessage
      v-if="sdkVisible"
      :show="showSdkMessage"
      @changeShow="changeShowSdkMessage"
      @sentMessage="sentMessage"
      :functionbox_uuid="functionbox_uuid"
    ></AddSDKMessage>
    <AddFaxMessage
      :show="showFaxMessage"
      @changeShow="changeShowFaxMessage"
      @sentMessage="sentMessage"
      :functionbox_uuid="functionbox_uuid"
    ></AddFaxMessage>
  </span>
</template>
<script>
import AddSefosMessage from "@/components/Compose/Message/SefosMessage";
import AddSDKMessage from "@/components/Compose/Message/SDKMessage";
import AddFaxMessage from "@/components/Compose/Message/FaxMessage";
export default {
  props: {
    functionbox_uuid: {
      default: "",
      type: String,
    },
    user_uuid: {
      default: "",
      type: String,
    },
  },
  components: {
    AddSefosMessage,
    AddSDKMessage,
    AddFaxMessage,
  },
  data() {
    return {
      showSefosMessage: false,
      showSdkMessage: false,
      showFaxMessage: false,
      sefosEnabled: false
    };
  },
  methods: {
    async init(){
      this.checkSefosEnabled();
    },
    async checkSefosEnabled(){     
      let self = this; 
      await this.$http
        .post(this.user.hostname + "/sefos-message/enabled",{
          organisation_uuid: this.user.information.organisation.organisation_uuid,
          functionbox_uuid: ""
        })
        .then(function(result) {
          self.sefosEnabled = result.data;
        })
        .catch(function() {
          self.sefosEnabled = false;
        });
    },
    changeShowSefosMessage(val) {
      this.showSefosMessage = val;
    },
    changeShowSdkMessage(val) {
      this.showSdkMessage = val;
    },
    changeShowFaxMessage(val) {
      this.showFaxMessage = val;
    },
    sentMessage() {
      this.showSefosMessage = false;
      this.showSdkMessage = false;
      this.showFaxMessage = false;
      this.$emit("sentMessage");
    },
  },
  computed: {
    showMultiple() {
      if (this.functionbox_uuid == "") {
        return false;
      } else {
        if(this.sdkVisible == true && this.faxVisible == true)
        {
          return true;
        }
        if(this.sdkVisible == true && this.sefosEnabled == true)
        {
          return true;
        }
        if(this.faxVisible == true && this.sefosEnabled == true)
        {
          return true;
        }
        return false;
      }
    },
    composeText() {
      return this.$t("MESSAGES.COMPOSE") + " - SEFOS";
    },
    faxVisible() {
      if (this.functionbox_uuid != "") {
        let self = this;
        let fb = this.user.functionboxes.items.filter(function (item) {
          return item.functionbox_uuid == self.functionbox_uuid;
        });
        if (fb.length == 0) {
          return false;
        } else {
          if (fb[0].fax_enabled != undefined) {
            return fb[0].fax_enabled;
          }
        }
      }
      return false;
    },
    sdkVisible() {
      if (this.user.ticket.sdk_enabled) {
        if (this.functionbox_uuid != "") {
          let self = this;
          let fb = this.user.functionboxes.items.filter(function (item) {
            return item.functionbox_uuid == self.functionbox_uuid;
          });
          if (fb.length == 0) {
            return false;
          } else {
            if (fb[0].sdk_enabled != undefined) {
              return fb[0].sdk_enabled;
            }
          }
        }
      }
      return false;
    },
  },
  mounted() {    
    this.init();
    //this.showSefosMessage = true;
    //this.showFaxMessage = true;
    //this.showSdkMessage = true;
  },
};
</script>
